<div class="identi-table-wrapper container py-5">
  <div class="row mb-5">
    <div class="col-12 text-center">
      <h4>
        <b> Our Plans </b>
      </h4>
    </div>
  </div>

  <div class="table-subheader-line-wrapper">
    <div class="first-column"></div>
    <div
      class="identi-subcolumn identi-subcolumn-top text-center"
      [class.identi-subcolumn-top-highlighted]="!!basicPlusHighlighted"
      [class.identi-subcolumn-highlighted]="!!basicPlusHighlighted"
    >
      <h4><b>identibase+</b></h4>
      <h5>£15/year</h5>
    </div>
    <div
      class="identi-subcolumn identi-subcolumn-top text-center"
      [class.identi-subcolumn-top-highlighted]="!!alertHighlighted"
      [class.identi-subcolumn-highlighted]="!!alertHighlighted"
    >
      <h4><b>identialert</b></h4>
      <h5>£36/year</h5>
      <h6>OR</h6>
      <h5>£4.99/month</h5>
      <h6>(12 month contract)</h6>
    </div>
    <div
      class="identi-subcolumn identi-subcolumn-top text-center"
      [class.identi-subcolumn-top-highlighted]="!!findHighlighted"
      [class.identi-subcolumn-highlighted]="!!findHighlighted"
    >
      <h4><b>identifind</b></h4>
      <h5>£36/year</h5>
      <h5>Plus a one off £129*</h5>
    </div>
  </div>
  <div class="table-line-wrapper table-line-wrapper-without_line">
    <div class="first-column column-orange-background">
      <h3 class="mb-0 mt-0"><b>Simple registration</b></h3>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    >
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
    </div>
  </div>
  <div class="table-line-wrapper">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/certificate-black.png"
      />
      <div>Annual keeper certificate</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    >
      <img
        [src]="
          !basicPlusHighlighted ? regularIconSource : highlightedIconSource
        "
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-line-wrapper">
    <div class="first-column">
      <img src="/assets/images/identibase/identi-table-icons/secure-data.svg" />
      <div>Secure data storage</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    >
      <img
        [src]="
          !basicPlusHighlighted ? regularIconSource : highlightedIconSource
        "
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-line-wrapper">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/secure-helpline.svg"
      />
      <div>Missing pet helpline</div>
    </div>
    <div
      class="identi-column helpline-row-item"
      [class.text-highlight]="!!basicPlusHighlighted"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    >
      24/7
    </div>
    <div
      class="identi-column helpline-row-item"
      [class.text-highlight]="!!alertHighlighted"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      24/7
    </div>
    <div
      class="identi-column helpline-row-item"
      [class.text-highlight]="!!findHighlighted"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      24/7
    </div>
  </div>

  <div class="table-line-wrapper">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/unlimited-account-changes.svg"
      />
      <div>Unlimited changes to your account</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    >
      <img
        [src]="
          !basicPlusHighlighted ? regularIconSource : highlightedIconSource
        "
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-line-wrapper table-line-wrapper-without_line">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/single-membership-covers.svg"
      />
      <div>Covers all pets in your household with an identichip microchip</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    >
      <img
        [src]="
          !basicPlusHighlighted ? regularIconSource : highlightedIconSource
        "
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>
  <div class="table-line-wrapper table-line-wrapper-without_line">
    <div class="first-column column-orange-background">
      <h3 class="mb-0 mt-0"><b>Lost Pet Protection cover</b></h3>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    ></div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
    </div>
  </div>
  <div class="table-line-wrapper">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/vet-surgery-icon.svg"
      />
      <div>Instant alert when your pet’s chip is scanned</div>
    </div>
    <div
      class="identi-column helpline-row-item"
      [class.text-highlight]="!!basicPlusHighlighted"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    >
      Email
    </div>
    <div
      class="identi-column helpline-row-item"
      [class.text-highlight]="!!alertHighlighted"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      SMS & Email
    </div>
    <div
      class="identi-column helpline-row-item"
      [class.text-highlight]="!!findHighlighted"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      SMS & Email
    </div>
  </div>
  <div class="table-line-wrapper">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/missing-pet-social-media.svg"
      />
      <div>Missing pet social media sharing</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    ></div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-line-wrapper">
    <div class="first-column">
      <img src="/assets/images/identibase/identi-table-icons/sms-alert.svg" />
      <div>SMS alerts to pet keepers in your area</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    ></div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-line-wrapper">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/alert-to-police.svg"
      />
      <div>
        Alerts sent to pet finders within 20 miles
      </div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    ></div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-line-wrapper">
    <div class="first-column">
      <img
        src="/assets/images/identibase/identi-table-icons/missing-pet-poster.svg"
      />
      <div>Missing pet support, advice and materials</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    ></div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    >
      <img
        [src]="!alertHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-line-wrapper">
    <div class="first-column">
      <img src="/assets/images/identibase/identi-table-icons/gps-tracker.svg" />
      <div>Real/time location tracking with PitPat GPS Tracker</div>
    </div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!basicPlusHighlighted"
    ></div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!alertHighlighted"
    ></div>
    <div
      class="identi-column"
      [class.identi-column-highlighted]="!!findHighlighted"
    >
      <img
        [src]="!findHighlighted ? regularIconSource : highlightedIconSource"
        class="table-checkmark"
      />
    </div>
  </div>

  <div class="table-subheader-line-wrapper">
    <div class="first-column"></div>
    <div
      class="identi-subcolumn identi-subcolumn-bottom text-center"
      [class.identi-subcolumn-bottom-highlighted]="!!basicPlusHighlighted"
      [class.identi-subcolumn-highlighted]="!!basicPlusHighlighted"
    ></div>
    <div
      class="identi-subcolumn identi-subcolumn-bottom text-center"
      [class.identi-subcolumn-bottom-highlighted]="!!alertHighlighted"
      [class.identi-subcolumn-highlighted]="!!alertHighlighted"
    ></div>
    <div
      class="identi-subcolumn identi-subcolumn-bottom text-center"
      [class.identi-subcolumn-bottom-highlighted]="!!findHighlighted"
      [class.identi-subcolumn-highlighted]="!!findHighlighted"
    >
      <div class="pb-4"></div>
    </div>
  </div>

  <div class="table-button-line-wrapper">
    <div class="first-column-placeholder"></div>
    <div class="identi-subcolumn-button-wrapper" >
      <button
        *ngIf="(buyButtonVisible || (!buyButtonVisible && !basicPlusHighlighted))"
        type="button"
        class="btn mt-4"
        [disabled]="buyButtonDisabled && !!basicPlusHighlighted"
        [class.orange-button]="!!basicPlusHighlighted"
        [class.outlined-button]="!basicPlusHighlighted"
        (click)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentibasePlusButton)
        "
      >
        {{ identibasePlusButtonLabel }}
      </button>
    </div>
    <div class="identi-subcolumn-button-wrapper" >
      <button
        *ngIf="(buyButtonVisible || (!buyButtonVisible && !alertHighlighted))"
        type="button"
        class="btn mt-4"
        [disabled]="buyButtonDisabled && !!alertHighlighted"
        [class.orange-button]="!!alertHighlighted"
        [class.outlined-button]="!alertHighlighted"
        (click)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentialertButton)
        "
      >
        {{ identialertButtonLabel }}
      </button>
    </div>
    <div class="identi-subcolumn-button-wrapper" >
      <div class="table-small-notice">*RRP £159</div>
      <button
        *ngIf="(buyButtonVisible || (!buyButtonVisible && !findHighlighted))"
        type="button"
        class="btn"
        [disabled]="buyButtonDisabled && !!findHighlighted"
        [class.orange-button]="!!findHighlighted"
        [class.outlined-button]="!findHighlighted"
        (click)="
          onIdentitableButtonClicked(IdentitableButtonEnum.IdentifindButton)
        "
      >
        {{ identifindButtonLabel }}
      </button>
    </div>
  </div>
</div>
